import { render, staticRenderFns } from "./viewAds.vue?vue&type=template&id=be1ea96a&"
import script from "./viewAds.vue?vue&type=script&lang=js&"
export * from "./viewAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports